import { Component } from '@angular/core';
import { environment } from '@pg-env/environment';

@Component({
  selector: 'np-login-error-phone',
  templateUrl: './login-error-phone.component.html',
  styleUrls: ['./login-error-phone.component.scss']
})
export class LoginErrorPhoneComponent {
  phone = environment.phone;
  domain = environment.domain;
  constructor() { }
}
